import View from '@/base/views/view';

class AutoTestResult extends View {
    
    static table = 'autotestresult';

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        const customerField = res.fields.find(f => f.name === 'CustomId')
        const createdUTCField = res.fields.find(f => f.name === 'CreatedUTC')
        const MessageField = res.fields.find(f => f.name === 'Message')
        const CommitField = res.fields.find(f => f.name === 'Commit')
        const FilesField = res.fields.find(f => f.name === 'Files')

        if (createdUTCField) {
            createdUTCField.hidden = false
            createdUTCField.hideFromList = false
        }

        if (customerField) {
            customerField.label = 'Customer'
            customerField.relation = 'customer'
            customerField.optionLabels = 'Name'
            customerField.editor = 'vue-select'
            customerField.filters = (r) => {return r.Project.Name == 'Nubbo'}
        }

        if (MessageField) {
            MessageField.editor = 'component'
            MessageField.component = 'json-editor'
            MessageField.hideFromList = true
            MessageField.headerField = true
        }

        if (!CommitField) {
            res.fields.push({
                name: 'Commit',
                label: 'Commit',
            })
        }

        if (!FilesField) {
            res.fields.push({
                name: 'Files',
                label: 'Files',
            })
        }

        res.canAdd = true;
        return res;
    }

}

export default AutoTestResult;